import type { UserInfo } from './UserContext';

type CurrentUserRoles =
  | (Pick<UserInfo, 'roles'> & Partial<Pick<UserInfo, 'isSystemAdmin'>>)
  | null
  | undefined;

const categoryManagerRoles = new Set([
  'editor',
  'developer',
  'admin',
  'superadmin',
  'systemadmin',
]);

const standardCmsRoles = new Set([...categoryManagerRoles, 'contributor']);

const adsAnalyticsAccessRoles = new Set([
  ...standardCmsRoles,
  'analyticsviewer',
  'analyticsalgorithmeditor',
]);

const hasAnyRole = (
  currentUser: CurrentUserRoles,
  allowedRoles: ReadonlySet<string>
) =>
  currentUser?.roles?.some(role =>
    allowedRoles.has(role.trim().toLowerCase())
  ) === true;

export const canReadAdsAnalyticsAccess = (currentUser: CurrentUserRoles) =>
  hasAnyRole(currentUser, adsAnalyticsAccessRoles);

export const canReadCmsSettings = (currentUser: CurrentUserRoles) =>
  hasAnyRole(currentUser, standardCmsRoles);

export const canReadContentSharingRequests = (currentUser: CurrentUserRoles) =>
  hasAnyRole(currentUser, standardCmsRoles);

export const hasCategoryManagementRestrictions = (
  currentUser: CurrentUserRoles
) =>
  currentUser?.isSystemAdmin !== true &&
  currentUser?.roles?.some(
    role => role.trim().toLowerCase() === 'contributor'
  ) === true &&
  !hasAnyRole(currentUser, categoryManagerRoles);
